class ExistsNumberCtrl {
    [x: string]: any;
 	 static $inject = ['OrderNumberService','VerificationNumberService','ipUserInfo','Toast', 'AmplitudeService', 'AccountService', 'Router'];
    constructor(OrderNumberService, VerificationNumberService, ipUserInfo, Toast, AmplitudeService, AccountService, Router) {
        this.OrderNumberService = OrderNumberService;
        this.VerificationNumberService = VerificationNumberService;
        this.ipUserInfo = ipUserInfo;
        this.toast = Toast;
        this.Amplitude = AmplitudeService;
        this.accountService = AccountService;
        this.router = Router;
        this.fullConfig = { data: true };
        this.hidden = true;
    }

    $onInit() {
      this.Amplitude.logEvent('Panel:Numbers:Own: Start');
      this.accountService.getAccountConfig().subscribe(conf => {
        this.isFullyConfigured = conf.data;
      });
    }

    back() {
      this.Amplitude.logEvent('Panel:Numbers:Own: Going back');
      this.OrderNumberService.backStep();
    }

    setPhoneNumber(msisdn, verifyType) {
      this.Amplitude.logEvent('Panel:Numbers:Own: Verify clicked', {
        verifyType: verifyType,
        locale: this.ipUserInfo.getCountry(),
      });
      this.VerificationNumberService.sendConfirmNumber({
            verifyType: verifyType,
            locale: this.ipUserInfo.getCountry(),
            msisdn: msisdn,
        }, () => {
            this.Amplitude.logEvent('Panel:Numbers:Own: Verification sent');
            this.msisdn = msisdn;
        })
    }

    confirm(code, label) {
        this.Amplitude.logEvent('Panel:Numbers:Own: Verify number');
        this.VerificationNumberService.confirmNumber({
            verificationCode: code,
            label: label,
            msisdn: this.msisdn
        }, () => {
            this.Amplitude.logEvent('Panel:Numbers:Own: Verification success', {
              ownPhoneNumber: this.msisdn,
              ownPhoneNumberCountryCode: this.ipUserInfo.getCountry()
            });
            this.redirectAfterConfirm();
            this.accountService.changeAccountConfig(this.fullConfig);
        })
    }

    redirectAfterConfirm() {
        if (this.isFullyConfigured) {
          this.router.navigate(['/phone-numbers'], { queryParams: { isNew: true } });
        } else {
          this.router.navigateByUrl('/extension');
        }
    }
}

export default {
    controller: ExistsNumberCtrl,
    template: require('./exists.number.html')
}
